import { Form } from 'antd'
import { useEffect, useState } from 'react'
import WizrInput from '../WizrInput'
import WizrTextArea from '../WizrTextArea'
import WizrFlexSpacing from '../WizrFlexSpacing'
import WizrButton from '../WizrButton'
import WizrFlexLayout from '../WizrFlexLayout'
import { styled } from 'styled-components'
import WizrDropDown from '../WizrDropDown'
import WizrText from '../WizrText'
import { dispatchEmbeddingModelList, dispatchVectorDb } from '../../redux/actions/content'
import { useEmbeddingModelListSelector, useVectorDb } from '../../redux/selectors/content'

const StyledContainer = styled(WizrFlexLayout)`
  gap: 8px;
`
const StyledDropDown = styled(WizrDropDown)`
  height: 50px;
  .ant-select-selector {
    height: 50px !important;
    .ant-select-selection-placeholder {
      margin-top: 10px;
    }
  }
`
interface ICreateUpdateFolderForm {
  folderName?: string
  folderDescription?: string
  embeddingModel?: string
  vectorDatabase?: string
  onFormSubmission: (params: { [key: string]: any }) => void
  onCancel: () => void
}

const CreateUpdateFolderForm = ({
  folderName,
  folderDescription,
  embeddingModel,
  vectorDatabase,
  onFormSubmission,
  onCancel,
}: ICreateUpdateFolderForm): JSX.Element => {
  const [form] = Form.useForm()
  const [currentFolderState, setCurrentFolderState] = useState({
    name: folderName || '',
    description: folderDescription || ''
  })

  useEffect(() => {
    form.setFieldValue('currentFolderName', folderName)
    form.setFieldValue('currentFolderDescription', folderDescription)
    form.setFieldValue('currentembeddingModel', embeddingModel)
    form.setFieldValue('currentVectorDatabase', vectorDatabase)
    setCurrentFolderState({
      name: folderName || '',
      description: folderDescription || ''
    })
  }, [folderName, folderDescription, embeddingModel, vectorDatabase])

  useEffect(() => {
    dispatchEmbeddingModelList()
    dispatchVectorDb()
    },[])

    const embeddingModelData = useEmbeddingModelListSelector()
    const vectorDbData = useVectorDb()

  const dropDownConverter = (value: string[]) => {
    const result =
      value?.length > 0 &&
      value?.map((item: any, key: number) => ({
        label: item.display_name,
        value: item.id,
      }))
    return result
  }

  const vectorDbDropDownConverter = (value: string[]) => {
    const result =
      value?.length > 0 &&
      value?.map((item: any, key: number) => ({
        label: item.display_name,
        value: item.id,
      }))
    return result
  }

  return (
    <StyledContainer background='#FFF' justifyContent='space-evenly'>
      <Form
        name='basic'
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFormSubmission}
        onFinishFailed={() => null}
        autoComplete='off'
      >
        <Form.Item
          name='currentFolderName'
          rules={[{ required: true, message: 'Please Enter a Folder Name', whitespace: true }]}
        >
          <WizrFlexLayout background='white' textAlign='left' style={{ gap: '10px' }}>
            <WizrText type='body2' textColor='#707276'>Folder Name</WizrText>
            <WizrInput
              placeholder='Enter Folder Name'
              onChange={(value: string) => {
                setCurrentFolderState({ ...currentFolderState, name: value })
                form.setFieldsValue({ currentFolderName: value })
              }}
              value={currentFolderState?.name}
            />
          </WizrFlexLayout>
        </Form.Item>
        <Form.Item name='currentFolderDescription' rules={[{ required: false, whitespace: true }]}>
          <WizrFlexLayout background='white' textAlign='left' style={{ gap: '10px' }}>
            <WizrText type='body2' textColor='#707276'>Description</WizrText>
            <WizrTextArea
              border='1px solid var(--grayscale-300, #DCDEE2)'
              placeholder='Description'
              onChange={(value: string) => {
                setCurrentFolderState({ ...currentFolderState, description: value })
                form.setFieldsValue({ currentFolderDescription: value })
              }}
              value={currentFolderState?.description}
            />
          </WizrFlexLayout>
        </Form.Item>
       {!folderName? <Form.Item
          name='currentembeddingModel'
          rules={[{ required: true, message: 'Please select an embedding model', whitespace: true }]}
        >
          <WizrFlexLayout background='white' textAlign='left' style={{ gap: '10px' }}>
            <WizrText type='body2' textColor='#707276'>Embedding Model</WizrText>
            <StyledDropDown
              value={embeddingModel}
              options={dropDownConverter(embeddingModelData)}
              onChange={(value: string) => { form.setFieldsValue({ currentembeddingModel: value })}}
            />
          </WizrFlexLayout>
        </Form.Item>:<></>}
        {!folderName? <Form.Item
          name='currentVectorDatabase'
          rules={[{ required: true, message: 'Please select a vector database', whitespace: true }]}
        >
          <WizrFlexLayout background='white' textAlign='left' style={{ gap: '10px' }}>
            <WizrText type='body2' textColor='#707276'>Vector Database</WizrText>
            <StyledDropDown
              value={vectorDatabase}
              options={vectorDbDropDownConverter(vectorDbData)}
              onChange={(value: string) => { form.setFieldsValue({ currentVectorDatabase: value })}}
            />
          </WizrFlexLayout>
        </Form.Item>:<></>}
        <Form.Item>
          <WizrFlexSpacing
            justifyContent='flex-end'
            flexDirection='row'
            size='large'
            background='#FFF'
          >
            <WizrButton type='default' text='Cancel' onClick={onCancel} style={{borderRadius: '20px'}}/>
            <WizrButton htmlType='submit' text={folderName ? 'Update' : 'Create'} style={{borderRadius: '20px'}}/>
          </WizrFlexSpacing>
        </Form.Item>
      </Form>
    </StyledContainer>
  )
}

export default CreateUpdateFolderForm
